<template>
  <div class="w-full p-5 strenths-weakness breaker">
    <bar-tooltip ref="barTooltip" />
    <chart-tooltip
      ref="tooltip"
      type="bar"
    />
    <playlist
      :popup-visible="popupVisible"
      @update:popupVisible="popupVisible = $event"
      :is-sum="false"
      :start-ability="abilityKey"
    />
    <div class="page-title">
      <h2>
        {{ content.title }}
        <p
          class="items-start text-xl"
          style="display:none;"
        >
          <question-icon
            v-if="!pdf"
            class="float-right float-top"
            :questions="content.questions"
          />
        </p>
        <span v-if="pdf && showSecondPagePdf">(page 1/2)</span>
      </h2>
      <br>
      <!-- <p class="items-start text-xl">
        {{ content.description }}
      </p> -->
    </div>

    <div
      class="categories"
      :class="{'breaker': showSecondPagePdf}"
      v-if="sortedData"
    >
      <h4
        class="transition duration-150 ease-in-out"
        data-bs-toggle="tooltip"
        title="The strongest abilities comes natural and easy and are often dominating."
      >
        {{ content.strongestTitle }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        ><path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
        />
        </svg>
      </h4>
      <div
        v-for="strength in strongest"
        :key="strength"
        class="flex grid items-center grid-cols-2"
      >
        <div
          class="staples"
        >
          <div class="flex flex-row items-center">
            <p>
              {{ sortedData[strength].label }}
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-7 h-7 m-4"
              @click="handleIconClick(strength)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
              />
            </svg>
            <!-- <div
              v-if="checkTestIssues(sortedData[strength].label) !== undefined && checkTestIssues(sortedData[strength].label).length > 0"
              class="issue-view-more-yellow"
            >
              <label
                v-if="checkTestIssues(sortedData[strength].label) !== undefined && checkTestIssues(sortedData[strength].label).length > 0"
                for="issue-support-modal"
                class="link modal-button text-sm flex flex-row items-start no-underline"
                @click="openViewMoreModal(checkTestIssues(sortedData[strength].label))"
              >
                <svg
                  v-if="checkTestIssues(sortedData[strength].label) !== undefined && checkTestIssues(sortedData[strength].label).length > 0"
                  width="16"
                  height="16"
                  class="mt-1"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10H15L10.5 5.5L15 1H1V17"
                    stroke="#1F2025"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p class="text-lg color-black-view p-0 m-0">  {{ checkTestIssues(sortedData[strength].label).length }} </p>
              </label>
            </div> -->
            <label
              v-if="checkTestIssues(sortedData[strength].label) !== undefined && checkTestIssues(sortedData[strength].label).length > 0"
              for="issue-support-modal"
              class="link modal-button text-sm flex flex-row items-start no-underline"
              @click="openViewMoreModal(checkTestIssues(sortedData[strength].label))"
            >
              <svg
                v-if="checkTestIssues(sortedData[strength].label) !== undefined && checkTestIssues(sortedData[strength].label).length > 0"

                width="16"
                height="16"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mx-3"
              >
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  fill="#CD2E00"
                />
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  stroke="#CD2E00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </label>
          </div>
          <div>
            <bar-chart
              v-if="loadedTooltip"
              :width="chartWidth"
              :height="chartHeight"
              :chart-data="createDataset(sortedData[strength])"
              :options="options"
            />
          </div>
        </div>
        <p>{{ content.abilityLevels[sortedData[strength].label][2] }}</p>
      </div>
    </div>
    <div
      v-if="pdf && showSecondPagePdf"
      class="pb-4 page-title "
    >
      <h2>
        {{ content.title }} (page 2/2)
      </h2>
    </div>

    <div
      v-if="challenges.length > 0"
      class="categories"
    >
      <h4>
        <strong>{{ content.functioningTitle }}</strong>
      </h4>
      <div
        v-for="challenge in challenges"
        :key="challenge"
        class="flex grid items-center grid-cols-2"
      >
        <div class="staples">
          <div class="flex flex-row items-center">
            <p>
              {{ sortedData[challenge].label }}
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-7 h-7 m-4"
              @click="handleIconClick(challenge)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
              />
            </svg>
            <!-- <div
              v-if="checkTestIssues(sortedData[challenge].label) !== undefined && checkTestIssues(sortedData[challenge].label).length > 0"
              class="issue-view-more-yellow"
            >
              <label
                v-if="checkTestIssues(sortedData[challenge].label) !== undefined && checkTestIssues(sortedData[challenge].label).length > 0"
                for="issue-support-modal"
                class="link modal-button text-sm flex flex-row items-start no-underline"
                @click="openViewMoreModal(checkTestIssues(sortedData[challenge].label))"
              >
                <svg
                  v-if="checkTestIssues(sortedData[challenge].label) !== undefined && checkTestIssues(sortedData[challenge].label).length > 0"
                  width="16"
                  height="16"
                  class="mt-1"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10H15L10.5 5.5L15 1H1V17"
                    stroke="#1F2025"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p class="text-lg color-black-view p-0 m-0">  {{ checkTestIssues(sortedData[challenge].label).length }} </p>
              </label>
            </div> -->
            <label
              v-if="checkTestIssues(sortedData[challenge].label) !== undefined && checkTestIssues(sortedData[challenge].label).length > 0"
              for="issue-support-modal"
              class="link modal-button text-sm flex flex-row items-start no-underline"
              @click="openViewMoreModal(checkTestIssues(sortedData[challenge].label))"
            >
              <svg
                v-if="checkTestIssues(sortedData[challenge].label) !== undefined && checkTestIssues(sortedData[challenge].label).length > 0"

                width="16"
                height="16"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mx-3"
              >
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  fill="#CD2E00"
                />
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  stroke="#CD2E00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </label>
          </div>
          <div>
            <bar-chart
              v-if="loadedTooltip"
              :width="chartWidth"
              :height="chartHeight"
              :chart-data="createDataset(sortedData[challenge])"
              :options="options"
            />
          </div>
        </div>
        <div class="">
          <p>{{ content.abilityLevels[sortedData[challenge].label ][1] }}</p>
        </div>
      </div>
    </div>

    <div
      v-if="development.length > 0"
      class="categories"
    >
      <h4>
        <strong>{{ content.investigateTitle }}</strong>
      </h4>
      <div
        v-for="dev in development"
        :key="dev"
        class="flex grid items-center grid-cols-2"
      >
        <div class="staples">
          <div class="flex flex-row items-center">
            <p>
              {{ sortedData[dev].label }}
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-7 h-7 m-4"
              @click="handleIconClick(dev)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
              />
            </svg>
            <!-- <div
              v-if="checkTestIssues(sortedData[dev].label) !== undefined && checkTestIssues(sortedData[dev].label).length > 0"
              class="issue-view-more-yellow"
            >
              <label
                v-if="checkTestIssues(sortedData[dev].label) !== undefined && checkTestIssues(sortedData[dev].label).length > 0"
                for="issue-support-modal"
                class="link modal-button text-sm flex flex-row items-start no-underline"
                @click="openViewMoreModal(checkTestIssues(sortedData[dev].label))"
              >
                <svg
                  v-if="checkTestIssues(sortedData[dev].label) !== undefined && checkTestIssues(sortedData[dev].label).length > 0"
                  width="16"
                  height="16"
                  class="mt-1"
                  viewBox="0 0 16 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10H15L10.5 5.5L15 1H1V17"
                    stroke="#1F2025"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p class="text-lg color-black-view p-0 m-0">  {{ checkTestIssues(sortedData[dev].label).length }} </p>
              </label>
            </div> -->
            <label
              v-if="checkTestIssues(sortedData[dev].label) !== undefined && checkTestIssues(sortedData[dev].label).length > 0"
              for="issue-support-modal"
              class="link modal-button text-sm flex flex-row items-start no-underline"
              @click="openViewMoreModal(checkTestIssues(sortedData[dev].label))"
            >
              <svg
                v-if="checkTestIssues(sortedData[dev].label) !== undefined && checkTestIssues(sortedData[dev].label).length > 0"

                width="16"
                height="16"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mx-3"
              >
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  fill="#CD2E00"
                />
                <path
                  d="M1 10H15L10.5 5.5L15 1H1V17"
                  stroke="#CD2E00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </label>
          </div>
          <div>
            <bar-chart
              v-if="loadedTooltip"
              :width="chartWidth"
              :height="chartHeight"
              :chart-data="createDataset(sortedData[dev])"
              :options="options"
            />
          </div>
        </div>
        <div class="">
          <p>{{ content.abilityLevels[sortedData[dev].label ][0] }}</p>
        </div>
      </div>
    </div>
    <div v-if="issueModalOpen">
      <input
        type="checkbox"
        id="issue-support-modal"
        class="modal-toggle"
      >
      <div
        class="modal"
        v-if="issueList.length > 0"
      >
        <div class="max-w-6xl modal-box p-16">
          <div class="flex justify-between">
            <h3 class="text-xl font-semibold mb-8">
              Issues experienced by candidate
            </h3>
            <svg
              width="16"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="cursor-pointer"
              @click="closeViewMoreModal()"
            >
              <mask
                id="path-1-inside-1_1025_3421"
                fill="white"
              >
                <path d="M10.4996 9.99402L19.8976 0.594181C19.9629 0.528297 19.9995 0.43934 19.9995 0.346637C19.9995 0.253935 19.9629 0.164978 19.8976 0.0990934C19.8307 0.0353672 19.7418 -0.000126685 19.6493 3.39773e-07C19.5569 0.000127365 19.4681 0.0358658 19.4014 0.0997756L10.0047 9.49893L0.606727 0.0990934C0.539791 0.0357843 0.451119 0.000502408 0.358944 0.000502408C0.266769 0.000502408 0.178098 0.0357843 0.111162 0.0990934C0.0459259 0.164862 0.00932661 0.253706 0.00932661 0.346296C0.00932661 0.438886 0.0459259 0.527731 0.111162 0.593499L9.50984 9.99402L0.111844 19.3939C0.077358 19.4259 0.0496848 19.4645 0.0304781 19.5074C0.0112714 19.5504 0.000925692 19.5967 5.93248e-05 19.6437C-0.000807043 19.6907 0.00782364 19.7375 0.0254356 19.7811C0.0430477 19.8247 0.0692792 19.8643 0.102563 19.8975C0.135847 19.9308 0.175499 19.957 0.21915 19.9746C0.262801 19.9922 0.309555 20.0008 0.356617 19.9999C0.40368 19.9991 0.450084 19.9887 0.493058 19.9696C0.536031 19.9504 0.574691 19.9227 0.606727 19.8883L10.0047 10.4891L19.402 19.8889C19.4345 19.9215 19.4731 19.9472 19.5156 19.9649C19.5581 19.9825 19.6036 19.9916 19.6496 19.9916C19.6956 19.9916 19.7411 19.9826 19.7836 19.965C19.8261 19.9475 19.8647 19.9218 19.8973 19.8893C19.9298 19.8568 19.9556 19.8183 19.9733 19.7758C19.9909 19.7334 20 19.6879 20 19.642C20 19.596 19.991 19.5505 19.9734 19.5081C19.9559 19.4656 19.9301 19.427 19.8976 19.3945L10.4996 9.99402Z" />
              </mask>
              <path
                d="M10.4996 9.99402L19.8976 0.594181C19.9629 0.528297 19.9995 0.43934 19.9995 0.346637C19.9995 0.253935 19.9629 0.164978 19.8976 0.0990934C19.8307 0.0353672 19.7418 -0.000126685 19.6493 3.39773e-07C19.5569 0.000127365 19.4681 0.0358658 19.4014 0.0997756L10.0047 9.49893L0.606727 0.0990934C0.539791 0.0357843 0.451119 0.000502408 0.358944 0.000502408C0.266769 0.000502408 0.178098 0.0357843 0.111162 0.0990934C0.0459259 0.164862 0.00932661 0.253706 0.00932661 0.346296C0.00932661 0.438886 0.0459259 0.527731 0.111162 0.593499L9.50984 9.99402L0.111844 19.3939C0.077358 19.4259 0.0496848 19.4645 0.0304781 19.5074C0.0112714 19.5504 0.000925692 19.5967 5.93248e-05 19.6437C-0.000807043 19.6907 0.00782364 19.7375 0.0254356 19.7811C0.0430477 19.8247 0.0692792 19.8643 0.102563 19.8975C0.135847 19.9308 0.175499 19.957 0.21915 19.9746C0.262801 19.9922 0.309555 20.0008 0.356617 19.9999C0.40368 19.9991 0.450084 19.9887 0.493058 19.9696C0.536031 19.9504 0.574691 19.9227 0.606727 19.8883L10.0047 10.4891L19.402 19.8889C19.4345 19.9215 19.4731 19.9472 19.5156 19.9649C19.5581 19.9825 19.6036 19.9916 19.6496 19.9916C19.6956 19.9916 19.7411 19.9826 19.7836 19.965C19.8261 19.9475 19.8647 19.9218 19.8973 19.8893C19.9298 19.8568 19.9556 19.8183 19.9733 19.7758C19.9909 19.7334 20 19.6879 20 19.642C20 19.596 19.991 19.5505 19.9734 19.5081C19.9559 19.4656 19.9301 19.427 19.8976 19.3945L10.4996 9.99402Z"
                fill="black"
              />
              <path
                d="M10.4996 9.99402L7.67091 7.16587L4.84341 9.99392L7.6708 12.8221L10.4996 9.99402ZM19.8976 0.594181L22.7263 3.42233L22.7327 3.41593L22.7391 3.40951L19.8976 0.594181ZM19.8976 0.0990934L22.7391 -2.71623L22.6984 -2.75732L22.6565 -2.79721L19.8976 0.0990934ZM19.4014 0.0997756L16.6345 -2.78892L16.6032 -2.75893L16.5725 -2.72827L19.4014 0.0997756ZM10.0047 9.49893L7.17602 12.3271L10.0048 15.1564L12.8335 12.327L10.0047 9.49893ZM0.606727 0.0990934L3.43543 -2.72906L3.39592 -2.76857L3.35533 -2.80697L0.606727 0.0990934ZM0.111162 0.0990934L-2.63744 -2.80697L-2.6838 -2.76312L-2.72874 -2.71781L0.111162 0.0990934ZM0.111162 0.593499L-2.72874 3.4104L-2.72315 3.41604L-2.71754 3.42165L0.111162 0.593499ZM9.50984 9.99402L12.3385 12.8222L15.1661 9.99402L12.3385 7.16587L9.50984 9.99402ZM0.111844 19.3939L2.83284 22.3258L2.88767 22.2749L2.94055 22.222L0.111844 19.3939ZM0.606727 19.8883L-2.22187 17.06L-2.27317 17.1113L-2.32257 17.1644L0.606727 19.8883ZM10.0047 10.4891L12.8335 7.66106L10.0049 4.8317L7.17612 7.66085L10.0047 10.4891ZM19.402 19.8889L22.2311 17.0611L22.2308 17.0609L19.402 19.8889ZM19.8976 19.3945L22.7266 16.5667L22.7264 16.5665L19.8976 19.3945ZM13.3283 12.8222L22.7263 3.42233L17.0689 -2.23397L7.67091 7.16587L13.3283 12.8222ZM22.7391 3.40951C23.5461 2.59496 23.9995 1.49435 23.9995 0.346637H15.9995C15.9995 -0.615675 16.3796 -1.53837 17.0561 -2.22114L22.7391 3.40951ZM23.9995 0.346637C23.9995 -0.801075 23.5461 -1.90168 22.7391 -2.71623L17.0561 2.91442C16.3796 2.23164 15.9995 1.30895 15.9995 0.346637H23.9995ZM22.6565 -2.79721C21.844 -3.57113 20.7649 -4.00154 19.6438 -4L19.6548 4C18.7187 4.00128 17.8174 3.64186 17.1387 2.99539L22.6565 -2.79721ZM19.6438 -4C18.5228 -3.99846 17.4448 -3.56507 16.6345 -2.78892L22.1682 2.98847C21.4913 3.6368 20.591 3.99871 19.6548 4L19.6438 -4ZM16.5725 -2.72827L7.17592 6.67089L12.8335 12.327L22.2302 2.92782L16.5725 -2.72827ZM12.8334 6.67078L3.43543 -2.72906L-2.22198 2.92724L7.17602 12.3271L12.8334 6.67078ZM3.35533 -2.80697C2.54527 -3.57313 1.47293 -3.9995 0.358944 -3.9995V4.0005C-0.570691 4.0005 -1.46569 3.6447 -2.14187 3.00516L3.35533 -2.80697ZM0.358944 -3.9995C-0.755041 -3.9995 -1.82738 -3.57313 -2.63744 -2.80697L2.85976 3.00516C2.18358 3.6447 1.28858 4.0005 0.358944 4.0005V-3.9995ZM-2.72874 -2.71781C-3.5367 -1.90326 -3.99067 -0.802094 -3.99067 0.346296H4.00933C4.00933 1.30951 3.62855 2.23298 2.95106 2.916L-2.72874 -2.71781ZM-3.99067 0.346296C-3.99067 1.49469 -3.5367 2.59585 -2.72874 3.4104L2.95106 -2.22341C3.62855 -1.54039 4.00933 -0.616913 4.00933 0.346296H-3.99067ZM-2.71754 3.42165L6.68114 12.8222L12.3385 7.16587L2.93987 -2.23465L-2.71754 3.42165ZM6.68114 7.16587L-2.71686 16.5657L2.94055 22.222L12.3385 12.8222L6.68114 7.16587ZM-2.60915 16.4619C-3.03768 16.8596 -3.38183 17.3398 -3.62079 17.8739L3.68174 21.1409C3.4812 21.5892 3.1924 21.9921 2.83284 22.3258L-2.60915 16.4619ZM-3.62079 17.8739C-3.85973 18.408 -3.98848 18.9849 -3.99926 19.57L3.99938 19.7174C3.99033 20.2085 3.88227 20.6927 3.68174 21.1409L-3.62079 17.8739ZM-3.99926 19.57C-4.01004 20.1552 -3.90262 20.7364 -3.68351 21.279L3.73438 18.2832C3.91827 18.7385 4.00843 19.2263 3.99938 19.7174L-3.99926 19.57ZM-3.68351 21.279C-3.4644 21.8215 -3.13816 22.3141 -2.7245 22.7273L2.92962 17.0677C3.27672 17.4145 3.5505 17.8278 3.73438 18.2832L-3.68351 21.279ZM-2.7245 22.7273C-2.31084 23.1406 -1.81824 23.4661 -1.27627 23.6845L1.71457 16.2646C2.16924 16.4479 2.58253 16.721 2.92962 17.0677L-2.7245 22.7273ZM-1.27627 23.6845C-0.734225 23.903 -0.153859 24.01 0.43017 23.9993L0.283065 16.0006C0.772969 15.9916 1.25983 16.0813 1.71457 16.2646L-1.27627 23.6845ZM0.43017 23.9993C1.0143 23.9885 1.59034 23.8602 2.12392 23.622L-1.1378 16.3171C-0.690173 16.1172 -0.206936 16.0096 0.283065 16.0006L0.43017 23.9993ZM2.12392 23.622C2.65751 23.3837 3.13783 23.0403 3.53603 22.6121L-2.32257 17.1644C-1.98844 16.8051 -1.58545 16.517 -1.1378 16.3171L2.12392 23.622ZM3.43533 22.7165L12.8333 13.3174L7.17612 7.66085L-2.22187 17.06L3.43533 22.7165ZM7.17592 13.3172L16.5732 22.717L22.2308 17.0609L12.8335 7.66106L7.17592 13.3172ZM16.573 22.7168C16.9769 23.1208 17.4562 23.4412 17.9836 23.6598L21.0476 16.2699C21.49 16.4533 21.8922 16.7221 22.2311 17.0611L16.573 22.7168ZM17.9836 23.6598C18.5108 23.8785 19.076 23.9912 19.6468 23.9916L19.6523 15.9916C20.1312 15.9919 20.6053 16.0865 21.0476 16.2699L17.9836 23.6598ZM19.6468 23.9916C20.2177 23.992 20.783 23.88 21.3105 23.6621L18.2567 16.268C18.6993 16.0852 19.1735 15.9913 19.6523 15.9916L19.6468 23.9916ZM21.3105 23.6621C21.8381 23.4442 22.3179 23.1246 22.7224 22.721L17.0722 17.0575C17.4115 16.719 17.8141 16.4507 18.2567 16.268L21.3105 23.6621ZM22.7224 22.721C23.1268 22.3176 23.4479 21.8383 23.6672 21.3104L16.2793 18.2413C16.4634 17.7983 16.7328 17.3961 17.0722 17.0575L22.7224 22.721ZM23.6672 21.3104C23.8865 20.7824 23.9996 20.2164 24 19.6447L16 19.6392C16.0003 19.1594 16.0952 18.6844 16.2793 18.2413L23.6672 21.3104ZM24 19.6447C24.0004 19.0731 23.8881 18.5069 23.6695 17.9786L16.2774 21.0375C16.0939 20.5942 15.9997 20.119 16 19.6392L24 19.6447ZM23.6695 17.9786C23.4509 17.4505 23.1305 16.9707 22.7266 16.5667L17.0686 22.2224C16.7297 21.8834 16.4608 21.4808 16.2774 21.0375L23.6695 17.9786ZM22.7264 16.5665L13.3284 7.16597L7.6708 12.8221L17.0688 22.2226L22.7264 16.5665Z"
                fill="black"
                mask="url(#path-1-inside-1_1025_3421)"
              />
            </svg>
          </div>
          <div v-if="issueList.length > 1">
            <ul
              class="space-y-1  list-disc list-inside neutral-grays-700"
              v-for="(item, index) in issueList"
              :key="index"
            >
              <li
                v-if="item.user === undefined"
                class="text-base my-6 ml-4 neutral-grays-700"
              >
                {{ item }}
              </li>
              <li
                v-if="item.user !== undefined && item.user === true"
                class="text-base my-6 ml-4 list-disc neutral-grays-700"
              >
                User comment: {{ item.issue }}
              </li>
            </ul>
          </div>
          <div v-if="issueList.length === 1">
            <ul
              class="space-y-1   list-inside neutral-grays-700"
              v-for="(item, index) in issueList"
              :key="index"
            >
              <li
                v-if="item.user === undefined"
                class="text-base my-6 "
              >
                {{ item }}
              </li>
              <li
                v-if="item.user !== undefined && item.user === true"
                class="text-base my-6 list-disc neutral-grays-700"
              >
                User comment: {{ item.issue }}
              </li>
            </ul>
          </div>
          <p class="text-base leading-9 mt-14 neutral-grays-700">
            <span v-if="lowScoreComments.length > 0">  An expert has analysed this result.</span> If you need support or if you would like to have more insight regarding issues candidate experienced while taking the test, please contact us.
          </p>
          <div
            class="flex items-center justify-center mt-6"
            @click="openChatbot()"
          >
            <label
              for="report-support-modal"
              class="btn-primary dashboard-create mt-5"
            > Contact us</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { CognitiveProfileStrengths } from '@/content/reportContent.json'
import { mapGetters } from 'vuex'
import Playlist from '@/components/Playlist.vue'

import { BarChart } from 'vue-chart-3'

import BarTooltip from './BarTooltip.vue'
import ChartTooltip from './ChartTooltip.vue'
import QuestionIcon from './QuestionIcon.vue'
// import IssueModal from '../../../components/modals/IssueModal.vue'

const attentionColor = 'rgb(95, 77, 62)'
const shortTermMemory = 'rgb(77, 83, 97)'
const workingMemory = 'rgb(79, 91, 117)'
const impulseControlColor = 'rgb(31, 32, 37)'
const creativityCognitiveFlexibilityColor = 'rgb(31, 32, 37)'
const conceptualizationColor = 'rgb(180, 156, 121)'
const strategicThinkingColor = 'rgb(180, 156, 121)'

const barColors = [
  attentionColor,
  attentionColor,
  shortTermMemory,
  workingMemory,
  impulseControlColor,
  creativityCognitiveFlexibilityColor,
  conceptualizationColor,
  strategicThinkingColor
]

export default {
  components: {
    BarChart,
    BarTooltip,
    ChartTooltip,
    QuestionIcon,
    Playlist
    // IssueModal
  },
  props: {
    chartData: {
      type: Array,
      required: true
    },
    pdf: {
      type: Boolean,
      required: true
    },
    testIssues: {
      type: Array,
      required: false,
      default: null
    },
    lowScoreComments: {
      type: Array,
      required: false,
      default: null
    }
  },
  data () {
    return {
      popupVisible: false,
      abilityKey: '',
      content: CognitiveProfileStrengths,
      sortedData: [],
      loadedTooltip: false,
      chartWidth: 600,
      chartHeight: 50,
      strongest: [],
      development: [],
      challenges: [],

      options: {
        animation: (this.pdf) ? {
          duration: 0
        } : undefined,
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false,
            external: null
          }
        },
        scales: {
          x: {
            display: false,
            ticks: {
              font: {
                size: 14
              }
            },
            max: 9,
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              display: false,
              font: {
                size: 16
              },
              color: 'black',
              callback: function (value) {
                const label = this.getLabelForValue(value)
                if (label.includes('&')) {
                  const split = label.split('&')
                  split[0] = `${split[0]} &`
                  return split
                }
                return label
              }
            }
          }
        }
      },
      issueList: [],
      issueModalOpen: false
    }
  },
  mounted () {
    this.sortedData = this.chartData.slice()
    barColors.forEach((el, idx) => {
      this.sortedData[idx].color = el
    })

    this.sortedData.sort((a, b) => parseInt(b.stanine) - parseInt(a.stanine))

    // Divide measures in Strongest, Challenges and Development areas

    const startStrongest = this.sortedData[0].stanine
    const duplicateStrongest = startStrongest === this.sortedData[1].stanine
    // const startDevelopment = this.sortedData[this.sortedData.length - 1].stanine

    this.sortedData.forEach((measure, index) => {
      if (measure.placeholder) return
      if (startStrongest - measure.stanine <= 1 && !duplicateStrongest) {
        this.strongest.push(index)
      } else if (startStrongest === measure.stanine && duplicateStrongest) {
        this.strongest.push(index)
      } else if (measure.stanine <= 3) {
        this.development.push(index)
      } else if (startStrongest - measure.stanine > 1 && !duplicateStrongest) {
        this.challenges.push(index)
      } else if (startStrongest > measure.stanine && duplicateStrongest) {
        this.challenges.push(index)
      }
    })
    this.loadedTooltip = true
    // this.options.plugins.tooltip.external = this.$refs.barTooltip.tooltipHandler
    this.checkTestIssues()
  },
  computed: {
    data () {
      return {
        labels: this.sortedData.map(el => el.label),
        datasets: [
          {
            label: 'The Candidate',
            data: this.sortedData.map(el => el.stanine),
            backgroundColor: this.sortedData.map(el => el.color)
          }
        ]

      }
    },
    showSecondPagePdf () {
      return this.strongest.length + this.challenges.length + this.development.length > 2
    },
    ...mapGetters({
      mainMeasures: 'REPORT/getMainMeasures'
    })
  },
  methods: {
    handleIconClick (el) {
      this.popupVisible = true
      this.abilityKey = this.sortedData[el].label
      console.log(this.abilityKey)
    },
    createDataset (result) {
      return {
        labels: [result.label],
        datasets: [
          {
            label: 'The Candidate',
            data: [result.stanine],
            backgroundColor: result.color
          }
        ]
      }
    },
    checkTestIssues (strName) {
      var dict = {
        'Attention Control': 'go_no_go',
        // eslint-disable-next-line quote-props
        'Conceptualization': 'sorting',
        'Creativity & Cognitive Flexibility': 'design_fluency',
        'Impulse Control': 'stroop',
        'Short Term Memory': 'grid',
        'Simple Attention': 'go',
        'Strategic Thinking': 'tower_of_london',
        'Working Memory': 'grid'
      }
      var dictIssue = {
        unclear_instructions: 'User experienced issued with unclear instructions.',
        technical_issues: 'User experienced some technical issues.',
        disturbance: 'User performed this test in a disturbed environment.',
        other_issues: ''
      }
      // eslint-disable-next-line quote-props
      const ablity = dict[strName]
      const fileter = this.testIssues.filter(el => el.type === ablity)
      // let issusList
      const issusList = []
      // if (fileter[0] !== undefined) {
      //   if (fileter[0].disturbance === true) { issusList = dictIssue.disturbance }
      //   if (fileter[0].technical_issues === true) issusList = issusList !== undefined ? issusList + '<br/>' + dictIssue.technical_issues : dictIssue.technical_issues
      //   if (fileter[0].unclear_instructions === true) issusList = issusList !== undefined ? issusList + '<br/>' + dictIssue.unclear_instructions : dictIssue.unclear_instructions
      //   if (fileter[0].other_issues !== null) issusList = issusList !== undefined ? issusList + '<br/>' + fileter[0].other_issues : fileter[0].other_issues
      // }
      if (fileter[0] !== undefined) {
        if (fileter[0].disturbance === true) { issusList.push(dictIssue.disturbance) }
        if (fileter[0].technical_issues === true) issusList.push(dictIssue.technical_issues)
        if (fileter[0].unclear_instructions === true) issusList.push(dictIssue.unclear_instructions)
        if (fileter[0].other_issues !== null && fileter[0].other_issues.length > 3) issusList.push({ user: true, issue: fileter[0].other_issues })
      }
      return issusList
    },
    openViewMoreModal (isList) {
      this.issueList = isList
      this.issueModalOpen = true
    },
    closeViewMoreModal () {
      this.issueModalOpen = false
      this.issueList = []
    },
    openChatbot () {
      this.$crisp.chat.show()
      this.$crisp.chat.open()
      this.$crisp.message.send('text', 'Hello I need help!')
      this.closeViewMoreModal()
    }
  }
}
</script>
<style scoped>

</style>
